import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosServiceShop from 'src/utils/axiosWOBaseUrl'; //Ye use hoga 

export const getStatusUpdaterList = createAsyncThunk(
    '/HeadOffice/StatusUpdaterRecords',
    async () => {
        const response = await axiosServiceShop.get('/HeadOffice/StatusUpdaterRecords');
        return response.data;
    }
);
export const getStatusUpdaterStatusesList = createAsyncThunk(
    '/HeadOffice/StatusUpdaterStatuses',
    async () => {
        const response = await axiosServiceShop.get('/HeadOffice/StatusUpdaterStatuses');
        return response.data;
    }
);
export const CreateStatusUpdater = createAsyncThunk(
    '/HeadOffice/CreateStatusUpdaterRule',
    async (data) => {
        const response = await axiosServiceShop.post('/HeadOffice/CreateStatusUpdaterRule', data);
        return response.data;
    }
);
export const UpateStatusUpdater = createAsyncThunk(
    '/HeadOffice/UpdateStatusUpdaterRule',
    async (data) => {
        const response = await axiosServiceShop.post('/HeadOffice/UpdateStatusUpdaterRule', data);
        return response.data;
    }
);

const statusUpdaterSlice = createSlice({
    name: 'statusUpdateMethod',
    initialState: {
        loading: false,
        error: '',
        statusUpdateData: [],
        statusUpdaterStatusesList: [],
        createResponse: [],
        updateResponse: [],
    },
    reducers: {
    },
    extraReducers: {
        // for statusupdater
        [getStatusUpdaterList.pending]: (state) => {
            state.loading = true;
        },
        [getStatusUpdaterList.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        [getStatusUpdaterList.fulfilled]: (state, action) => {
            state.statusUpdateData = action.payload;
            state.loading = false;
        },
        // for statusupdater statuses
        [getStatusUpdaterStatusesList.pending]: (state) => {
            state.loading = true;
        },
        [getStatusUpdaterStatusesList.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        [getStatusUpdaterStatusesList.fulfilled]: (state, action) => {
            state.statusUpdaterStatusesList = action.payload;
            state.loading = false;
        },
        //  for creating StatusUpdater 
        [CreateStatusUpdater.pending]: (state) => {
            state.loading = true;
        },
        [CreateStatusUpdater.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        [CreateStatusUpdater.fulfilled]: (state, action) => {
            state.createResponse = action.payload;
            state.loading = false;
        },
        //  for Updating StatusUpdater
        [UpateStatusUpdater.pending]: (state) => {
            state.loading = true;
        },
        [UpateStatusUpdater.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        [UpateStatusUpdater.fulfilled]: (state, action) => {
            state.updateResponse = action.payload;
            state.loading = false;
        },
    }
});

export const statusUpdaterActions = statusUpdaterSlice.actions;

export default statusUpdaterSlice;
